import { Navigate, Outlet, useLocation } from 'react-router-dom'

function isAuthenticated(): boolean {
  return !!localStorage.getItem('auth_token')
}

/** Protects app routes — redirects to /sign-in if not logged in */
export function PrivateRoute() {
  const location = useLocation()
  if (!isAuthenticated()) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />
  }
  return <Outlet />
}

/** Redirects logged-in users away from auth pages */
export function PublicRoute() {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />
  }
  return <Outlet />
}
